import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/EditorialMarquee";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { Gallery } from "@/components/site/Gallery";
import { Testimonials } from "@/components/site/Testimonials";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  return (
    <main className="bg-cream" data-testid="home-page">
      <Navbar />
      <Hero />
      <EditorialMarquee />
      <About />
      <Services />
      <Gallery />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
